import { EditorFromTextArea } from 'codemirror';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EditorConfig } from '../../editor-config';
import { CodemirrorLinksMentionsAndHashtags } from './codemirror-twitter-mentions/codemirror-links-mentions-and-hashtags';
import { SingleMessage } from './single-message';

/**
 * Groups a couple of instances that are needed by various components related to the CodeMirror editor.
 * The first reason to create this class was to avoid the ExpressionChangedAfterItHasBeenCheckedError hell,
 * but it might also make for fewer dependencies among components, we'll see
 */
export class CodemirrorContext {
  public codeMirror?: EditorFromTextArea;
  public isCodeMirror = !environment.isNativeApp;
  public linksAndMentionsDetector: CodemirrorLinksMentionsAndHashtags;
  public escapePressed$ = new Subject<void>();
  public tabPressed$ = new Subject<void>();
  public cursorActivity$ = new Subject<void>();
  public isSpellCheckerEnabled = false;
  public languageCode: string;

  constructor(private editorConfig: EditorConfig, public siteId: number, public message: SingleMessage) {
    if (this.isCodeMirror) {
      this.linksAndMentionsDetector = new CodemirrorLinksMentionsAndHashtags(this);
      this.isSpellCheckerEnabled = editorConfig.isSpellCheckerEnabledForCompany;
    }
  }

  get hasMentionDetector() {
    return this.editorConfig.useTwitterPublicEditor;
  }

  shouldSuggestFavorites(favorites) {
    return !environment.isNativeApp && favorites && favorites.length > 0;
  }

  init() {
    if (this.linksAndMentionsDetector) {
      this.linksAndMentionsDetector.init();
    }
  }
}
